<template>
  <div class="catalog-sections">
    <CatalogSectionMenu />
    <CatalogSort :result="catalogSort" @changeSort="catalogStore.changePageData" />
    <section class="catalog-sections__items pagination-scroll-js">
      <CatalogSectionItem v-for="(item, index) in items" :key="item.id" :result="item" />
    </section>
    <CatalogPagination
      :result="pagination"
      @changePage="catalogStore.changePageData"
      @addMore="catalogStore.getMoreItems"
    />
  </div>
</template>

<script lang="ts" setup>
import CatalogSectionMenu from '@components/Catalog/CatalogSections/CatalogSectionMenu.vue';
import CatalogSort from '@components/Catalog/CatalogSort/CatalogSort.vue';
import CatalogSectionItem from '@components/Catalog/CatalogSections/CatalogSectionItem.vue';
import CatalogPagination from '@components/Catalog/CatalogPagination/CatalogPagination.vue';
import { useCatalogStore } from '@/storePinia/stores/catalog';
import { computed } from 'vue';

const catalogStore = useCatalogStore();

const items = computed(() => catalogStore.catalogSectionList?.items);
const pagination = computed(() => catalogStore.catalogSectionList?.pagination);
const catalogSort = computed(() => catalogStore.catalogSort);
</script>

<style lang="scss" scoped>
.catalog-sections {
  @include block-mb;
  &__items {
    display: grid;
    margin-bottom: 4px;
    grid-gap: 4px;
    grid-template-columns: minmax(0, 1fr);
    @include point-md {
      margin-bottom: 8px;
      grid-gap: 8px;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @include point-lg {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  :deep(.catalog-sort) {
    width: 100%;
    margin-bottom: 16px;
    @include point-md {
      .def-button-secondary {
        width: unset;
      }
    }
    @include point-lg {
      margin-bottom: 24px;
    }
  }
}
</style>
